import { render, staticRenderFns } from "./AudioCallBtn.vue?vue&type=template&id=476605f5&scoped=true&"
import script from "./AudioCallBtn.vue?vue&type=script&lang=js&"
export * from "./AudioCallBtn.vue?vue&type=script&lang=js&"
import style0 from "./AudioCallBtn.vue?vue&type=style&index=0&id=476605f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476605f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
